import { render } from "./orderlist.vue?vue&type=template&id=44aa475e"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"

import "./orderlist.vue?vue&type=style&index=0&id=44aa475e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__